import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MpImgPage } from './image-tag.page';

const routes: Routes = [
  {
    path: '',
    component: MpImgPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MpImgPageRoutingModule {}
